"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionPlanService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class SubscriptionPlanService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    fetchSubscriptionPurchaseOrderService(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}pay_per_user_purchase_order/list?page=${payload.pageNumber}&limit=${payload.limit}`;
                if (payload.status != undefined && payload.status != null && payload.status != '')
                    url += '&status=' + payload.status;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const respData = response.data.data;
                return respData;
            }
            catch (error) {
                throw new Error("Error while fetching subscription purchase order service");
            }
        });
    }
    createSubscriptionPurchaseOrderService(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}pay_per_user_purchase_order/create`;
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.post(url, payload, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                return response.data.data;
            }
            catch (error) {
                throw new Error("Error while creating subscription purchase order service");
            }
        });
    }
    updateSubscriptionPurchaseOrderService(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}pay_per_user_purchase_order/edit`;
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.put(url, payload, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                return response.data.message;
            }
            catch (error) {
                throw new Error("Error while updating subscription purchase order service");
            }
        });
    }
    cancelSubscriptionPurchaseOrderService() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}pay_per_user_purchase_order/cancel`;
                const response = yield axios_1.default.put(url, null, {
                    headers: header,
                });
                return response.data.message;
            }
            catch (error) {
                throw new Error("Error while cancelling subscription purchase order service");
            }
        });
    }
}
exports.SubscriptionPlanService = SubscriptionPlanService;
